<div class="tp-shell">
  <app-header-marchand></app-header-marchand>
  <div class="tp-body">
    <aside class="tp-sidebar">
      <app-side-bar-marchand></app-side-bar-marchand>
    </aside>
    <main class="tp-main">
      <app-tab-view-marchand></app-tab-view-marchand>
    </main>
  </div>
</div>